import { forwardRef } from 'react';
import MuiContainer, { type ContainerProps as MuiContainerProps } from '@mui/material/Container';

export type ContainerProps = MuiContainerProps;

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ maxWidth = 'md', ...rest }, ref) => <MuiContainer ref={ref} maxWidth={maxWidth} {...rest} />
);

Container.displayName = 'Container';
